import { render, staticRenderFns } from "./QuesAnsA.vue?vue&type=template&id=697d1434&scoped=true&"
import script from "./QuesAnsA.vue?vue&type=script&lang=js&"
export * from "./QuesAnsA.vue?vue&type=script&lang=js&"
import style0 from "./QuesAnsA.vue?vue&type=style&index=0&id=697d1434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697d1434",
  null
  
)

export default component.exports